import React, { useEffect, useState } from 'react';
// import '../Revenue.css'
import INCSUBSearchbar from '../../components/common/SearchBar/INCSUBSearchbar';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { getTxnReqList } from '../../services/revenueServices';
import { setTxnReqList } from '../../features/revenue/revenueSlice';
import ReactPaginate from 'react-paginate';
import INCSUBButton from '../../components/common/Button/INCSUBButton';
import INCSUBUserPaymentDetails from './userPaymentDetails/UserPaymentDetails';
import { setSelectedPayment, setUserPaymentList, setUserPaymentPath } from '../../features/userPayments/userPaymentSlice';
import { getUserpaymentList } from '../../services/userPaymentServices';
import INCSUBFilterList from '../../components/common/filter/FilterList';
// import INCSUBPaymentDetails from '../paymentDetails/PaymentDetails';



function INCSUBUserPayments() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [pageNumber, setPageNo] = useState(0);
    const [searchKey, setSearchKey] = useState('');
    const userPaymentPath = useSelector((state) => state.userPayment.userPaymentPath)
    const txnReqList = useSelector((state) => state.userPayment.userPaymentList)
    const [isFocused, setIsFocused] = useState('Income')
    const [currentPage, setCurrentPage] = useState(0);
    const [shimmer, setShimmer] = useState(false);
     const [status, setStatus] = useState('All');
    const selectedPayment = useSelector((state)=>state.userPayment.selectedPayment);
  const VerificationStatusList = [
    { id: 'All', name: 'All' },
    { id: 'Pending', name: 'Pending' },
    { id: 'Rejected', name: 'Rejected' },
  ];
    const fetchRequestList = async (searchKey = '', pageNo = pageNumber, filter="All") => {
        try {
            const txnData = await getUserpaymentList(pageNo, searchKey,filter);
            if (txnData.status === 200) {
                dispatch(setUserPaymentList(txnData.data.data))
            } else if (txnData.status === 301) {
                toast.error("Network Error");
            } else if (txnData.status === 500) {
                toast.error("Internal server error");
            } else if (txnData.status === 401) {
                window.localStorage.setItem('userData', null);
                window.localStorage.setItem('token', null);
                navigate('/login');
            } else if (![200, 401, 500].includes(txnData.status)) {
                toast.error(txnData.data.message)
            }
        } catch (error) {
            toast.error("Something went wrong")
        } finally {
        }
    }
    useEffect(() => {
        if(userPaymentPath==='/userPayment'){
  fetchRequestList();
        }
      
    }, [])

  const formatDateTime = (dateTime) => {
    const date = new Date(dateTime);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    const formattedDate = date.toLocaleDateString("en-GB", options).replace(",", "");
    const hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const period = hours >= 12 ? "PM" : "AM";
    const formattedTime = `${hours % 12 || 12}:${minutes} ${period}`;

    return `${formattedDate} ${formattedTime}`;
  };
    const handleSearch = (searchKey) => {
        setSearchKey(searchKey)
        fetchRequestList(searchKey)
    }

    const handleVerification = async (payment) => {
        dispatch(setSelectedPayment(payment))
        dispatch(setUserPaymentPath("/userPaymentDetails"))
    }
    const handleStatusChange = (status) => {
        setStatus((prevStatus) => {
            const newStatus = status.name;
            fetchRequestList(searchKey, pageNumber, newStatus ); // Pass the updated state if needed
            return newStatus;
        });

    }
    function PaginatedItems() {
        const [itemOffset, setItemOffset] = useState(0);
        const pageCount = txnReqList ? txnReqList.totalPages : 0;
        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
            setPageNo(event.selected);
            fetchRequestList(searchKey, event.selected, "All")
            setCurrentPage(event.selected)
            setItemOffset(event.selected);
        };


        return (

            <div className='INCSUBComplaints_list_section_container'>{
                !shimmer && txnReqList && txnReqList?.requestList && txnReqList?.requestList?.length > 0 && pageCount > 1 ? <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    forcePage={currentPage}
                /> : null
            }
            </div>


        );
    }
    return (
        <>{userPaymentPath === "/userPayment" ? <div className='INCSUBRevenue_ctn'>
            <div className='INCSUBRevenue_ctn_search_cal_btn_div'>
                <div className='INCSUBRevenue_ctn_search_cal'>
                    <INCSUBSearchbar width={500} height={38} backgroundColor='#fff' placeholder={'Search'} param={{ func: handleSearch }} />
                      <INCSUBFilterList list={VerificationStatusList} value={status} func={handleStatusChange} type={"Status"}/>
                </div>

            </div>
            <div className='INCSUBRevenue_content_container'>

                <div className='INCSUBUser_userlist_section'>
                    {txnReqList && txnReqList?.requestList?.length > 0 ?
                        <div className='INCSUBUser_userlist_section_table_conatiner'>
                            <table className='INCSUBuser_table'>
                                <thead className='INCSUBuser_table_head'>
                                    <tr>
                                        <th>#</th>
                                        <th>User Image</th>
                                        <th>Pool Name</th>
                                        <th>Amount </th>
                                        <th>Date</th>
                                         <th>status</th>
                                        <th>Action</th>
                                        
                                    </tr>
                                </thead>
                                <tbody className='INCSUBuser_table_body'>
                                    {
                                        txnReqList && txnReqList?.requestList?.length > 0 && txnReqList?.requestList.map((txn, index) =>
                                            <tr>
                                        <td>{index+1}</td>

                                        <td><div className='INCSUBprofile_name_container'>
                                            <div className='name_conatiner'>
                                                <div className='name'>{txn?.userFullName}</div>
                                                <div className='mobile_no'>{txn?.userMobileNumber}</div>
                                            </div>
                                        </div>
                                        </td>
                                        <td>{txn?.poolName}</td>
                                        <td>₹ {txn?.transactionAmount}</td>
                                        <td>{formatDateTime(txn?.requestCreatedAt)}</td>
                                            <td className={`paymentVerification ${txn?.requestStatus}`} style={{color:txn?.requestStatus==="Pending"?"red":'rgb(0 31 255)'}}>{txn?.requestStatus}</td>
                                        <td><div className='INCSUBRevenue_listui_ctn_rowHeading_Amount' style={{ color: 'rgba(32, 34, 36, 1)', fontWeight: 500 }}>
                                            <INCSUBButton text='Preview' clickFun={() => handleVerification(txn)} />
                                        </div></td>

                                    </tr>)
                                    }
                                </tbody>
                            </table>
                        </div> :
                        <div className='INCSUBRevenue_empty'>No Data Available</div>}
                </div>
                <PaginatedItems />

            </div>
        </div> : (userPaymentPath === '/userPaymentDetails' ? <INCSUBUserPaymentDetails  info={selectedPayment}/> : null)}</>
    )
}

export default INCSUBUserPayments;
